import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const problems = ['You spend too much time searching for sequences or building routines at the last minute', "You don't have a clear progression by level and end up repeating the same stretches every week", 'You arrive at your sessions without a fluid structure and spend too long explaining instead of teaching', 'You have no organized library of stretching protocols to pull from without starting from scratch', 'When the week gets complicated, your planning falls apart and you improvise too much', "You want to look more prepared and professional — but without a ready system you waste hours you simply don't have"];
export function ProblemSection() {
  return <section className="py-12 sm:py-24 bg-slate-50 relative overflow-hidden" data-id="element-192">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-[radial-gradient(#e2e8f0_1px,transparent_1px)] [background-size:16px_16px] opacity-50" data-id="element-193" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-194">
        <div className="mx-auto max-w-3xl text-center mb-8 sm:mb-16" data-id="element-195">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl text-balance" data-id="element-196">
            IF EVERY WEEK YOU WASTE HOURS PLANNING YOUR CLASSES,{' '}
            <span className="text-rose-600" data-id="element-197">THIS WILL SOUND FAMILIAR:</span>
          </h2>
        </div>

        <div className="mx-auto max-w-4xl" data-id="element-198">
          <div className="grid gap-3 sm:gap-6 sm:grid-cols-2" data-id="element-199">
            {problems.map((problem, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex gap-3 sm:gap-4 rounded-xl sm:rounded-2xl bg-slate-50 p-4 sm:p-6 ring-1 ring-slate-100 shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5 cursor-default" data-id="element-200">
                <XCircle className="h-5 w-5 sm:h-6 sm:w-6 flex-none text-rose-500" data-id="element-201" />
                <p className="text-sm sm:text-base text-slate-700 leading-relaxed" data-id="element-202">
                  {problem}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}